module.exports = __webpack_public_path__ + "static/media/WhatsApp Image 2021-09-21 at 11.13.52 PM.68c98615.jpeg";